/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    TextField,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ModalEncabezado from 'Infotrack@Transversales/componentes/ModalEncabezado/ModalEncabezado';
import React from 'react';
import { IFormularioDivisionesTiposPropiedadesVistaProps } from '../interfaces';
const FormularioDivisionesTiposPropiedadesVista: React.FunctionComponent<IFormularioDivisionesTiposPropiedadesVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    divisionesTiposPropiedades,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <ModalEncabezado
            cerrar={cerrarFormulario}
            titulo={
                <Texto
                    align="center"
                    color="inherit"
                    id={
                        tipoFormulario === TipoFormulario.Creacion
                            ? 'divisionesTiposPropiedades.agregarDivisionesTiposPropiedades'
                            : 'divisionesTiposPropiedades.modificarDivisionesTiposPropiedades'
                    }
                />
            }
        />
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={
                            <Texto id="divisionesTiposPropiedades.divisionTipoPropiedadDescripcion" display="inline" />
                        }
                        name="DivisionTipoPropiedadDescripcion"
                        onChange={cambiarInfoFomulario}
                        required
                        value={divisionesTiposPropiedades.DivisionTipoPropiedadDescripcion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="divisionesTiposPropiedades.propiedad" display="inline" />}
                        name="Propiedad"
                        onChange={cambiarInfoFomulario}
                        required
                        value={divisionesTiposPropiedades.Propiedad}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={Number(divisionesTiposPropiedades.Estado) === 1 ? true : false}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="productos.estado" display="inline" />}
                        name="Estado"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            {tipoFormulario !== TipoFormulario.Visualizacion ? (
                <div>
                    <Grid container justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                                <Texto id="boton.cancelar" />
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button onClick={accionCrearEditar} color="primary" variant="contained">
                                <Texto id="boton.guardar" />
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                    <Texto id="boton.cerrar" />
                </Button>
            )}
        </DialogActions>
    </Dialog>
);

export default FormularioDivisionesTiposPropiedadesVista;
